import type { CheckedAssemblyItem } from '../context/AssemblyItemsContext'

export const isChecked = (
  checkedAssemblies: CheckedAssemblyItem[],
  currentAssembly: CheckedAssemblyItem
) => {
  return checkedAssemblies.some(
    (checkedAssembly) =>
      checkedAssembly.id === currentAssembly.id &&
      checkedAssembly.assemblyId === currentAssembly.assemblyId
  )
}
